'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import type { APILanguage } from '@openclassrooms/sdk';
import { initAiSdk } from '@/modules/ai-sdk';
type Props = {
  children: React.ReactNode;
  language: string;
};
export default function AiSdkProvider(t0) {
  const $ = _c(4);
  const {
    children,
    language
  } = t0;
  let t1;
  if ($[0] !== language) {
    t1 = () => {
      initAiSdk({
        language: language as APILanguage
      });
    };
    $[0] = language;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useState(t1);
  let t2;
  if ($[2] !== children) {
    t2 = <>{children}</>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}